import * as React from "react";
const SvgFiRrPalette = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-palette_svg__a)">
      <path d="M17.115 8.05a1.5 1.5 0 1 0 .77 2.899 1.5 1.5 0 0 0-.77-2.899M12.115 5.05a1.5 1.5 0 1 0 .77 2.899 1.5 1.5 0 0 0-.77-2.899M7.115 8.05a1.5 1.5 0 1 0 .77 2.9 1.5 1.5 0 0 0-.77-2.9M7.115 14.05a1.5 1.5 0 1 0 .77 2.899 1.5 1.5 0 0 0-.77-2.899" />
      <path d="M12.5.007A12 12 0 0 0 .083 12a12.014 12.014 0 0 0 12 12c.338 0 .67-.022 1-.05a1 1 0 0 0 .916-1l-.032-3.588a3.567 3.567 0 0 1 6.09-2.562l.1.1a1.91 1.91 0 0 0 1.769.521 1.89 1.89 0 0 0 1.377-1.177c.552-1.45.816-2.993.777-4.544A12.155 12.155 0 0 0 12.5.007m8.982 15.4-.014-.014a5.567 5.567 0 0 0-9.5 3.985L11.992 22a10 10 0 1 1 .09-20q.176-.001.353.006a10.127 10.127 0 0 1 9.645 9.743 9.9 9.9 0 0 1-.595 3.651z" />
    </g>
    <defs>
      <clipPath id="fi-rr-palette_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPalette;
